<form #formulario="ngForm">
    <mat-accordion>

        <mat-expansion-panel [expanded]="openFormCadastro" (closed)="openFormCadastro = false">
            <mat-expansion-panel-header>
                <mat-panel-title>Dados do Item</mat-panel-title>
            </mat-expansion-panel-header>

            <mat-toolbar class="titulopartes">Dados Iniciais</mat-toolbar>
            <div fxLayout="row" fxLayoutGap="50px" style="padding-top: 10px !important;" fxFlexFill>
                <div ngModelGroup="cbProjeto" fxFlex="100%" fxLayoutGap="20px" class="marginCombo">
                    <combo-projeto [showDisplayId]="false"
                                [obrigatorio]="true" 
                                [selecionado]="itensMovimentacoes.projeto"
                                (valorChange)="changeProjeto($event)">
                    </combo-projeto>
                </div>
            </div>
            <div fxLayout="row" fxLayoutGap="50px" style="padding-top: 10px !important;" fxFlexFill>
                <div ngModelGroup="comboRubrica" fxFlex="100%" fxLayoutGap="20px" class="marginCombo">
                    <combo-rubrica  [showDisplayId]="false"
                                    [obrigatorio]="true"
                                    [hasSintetica]="false"
                                    [selecionado]="itensMovimentacoes.categoria"
                                    [label]="placeHolderRubrica"
                                    (valorChange)="carregarContaContabil($event)"
                                    [placeholder]="placeHolderRubrica">
                    </combo-rubrica>
                </div> 
            </div> 

            <div fxLayout="row" fxLayoutGap="50px" style="padding-top: 15px !important;" fxFlexFill>
                <div ngModelGroup="comboPedidoMaterial"
                     fxFlex="100%" fxLayoutGap="20px" fxFlexOffset="20px" class="marginCombo">
                    <combo-pesquisavel #comboPedidoMaterial 
                                       nome="comboPedidoMaterial" 
                                       [itens]="pedidosMateriais" 
                                       itemDescricao="descricaoPedido"
                                       itemId="id"
                                       label="Pedido Material"
                                       [obrigatorio]="false"
                                       placeholder="Escolha..."
                                       [(valor)]="itensMovimentacoes.pedidosMateriais"
                                       style="margin-top: 10px;">
                    </combo-pesquisavel>                    
                </div>                
            </div>
    
            <div fxLayout="row" fxLayoutGap="50px" style="padding-top: 15px !important;" fxFlexFill >
                <div ngModelGroup="comboRubricaAdicional" fxFlex="100%" fxLayoutGap="20px" class="marginCombo">
                    <combo-rubrica  [showDisplayId]="false"
                                    [hasSintetica]="false"
                                    [selecionado]="itensMovimentacoes.categoriaAdicional"
                                    [label]="placeHolderRubricaAdicional"
                                    (valorChange)="carregarContaContabilAdicional($event)"
                                    [placeholder]="placeHolderRubricaAdicional">
                    </combo-rubrica>                    
                </div> 
            </div>   

            <div fxLayout="row" fxLayoutGap="50px" style="padding-top: 15px !important;">
                <mat-form-field fxFlexOffset="20px" fxFlex="15%">
                    <input (ngModelChange)="multiplicar($event)" 
                            [(ngModel)]="itensMovimentacoes.valorUnitarioItem" 
                            currencyMask name="valorUnitario" 
                            placeholder="Valor Unitário:" 
                            matInput maxlength="13"
                            [options]="{ prefix: '', thousands: '.', decimal: ',' }" />
                    <span matPrefix>R$&nbsp;</span>
                </mat-form-field>
    
                <mat-form-field fxFlex="10%" >
                    <input type="number" 
                           (input)="multiplicarComQuantidade()" 
                           [(ngModel)]="itensMovimentacoes.quantidadeMaterial"  
                           matInput 
                           [min]="1" 
                           maxlength="3" 
                           name="qtdParcelas"
                           placeholder="Quantidade" />
                </mat-form-field>
    
                <mat-form-field fxFlexOffset="20px" fxFlex="15%">
                    <input [(ngModel)]="itensMovimentacoes.valorTotalItem"
                            currencyMask name="valorTotal" 
                            placeholder="Valor Total:" 
                            matInput maxlength="13"
                            [options]="{ prefix: '', thousands: '.', decimal: ',' }" 
                            disabled />
                    <span matPrefix>R$&nbsp;</span>
                </mat-form-field>
    
            </div>

            <!--
            <mat-toolbar class="titulopartes">Tributos</mat-toolbar>
            <div fxLayout="column" fxLayoutGap="50px" fxFlexFill>
                <div fxFlex="100%" fxFlexOffset="20px" ngModelGroup="grupoTributo">
                    <div *ngFor="let tributo of itensMovimentacoes.tributos; let index = index">
                        <formulario-tributo [tributoMovimentacao]="tributo" 
                                            [index]="index"
                                            [tributosMovimentacao]="itensMovimentacoes.tributos"  
                                            [tributos]="tributos" 
                                            [showInputValor]="false"
                                            [perfilAcesso]="perfilAcesso"
                                            [faturas]="movimentacoes.faturas">
                        </formulario-tributo>
                    </div>
                    <div *ngIf="perfilAcesso.insere" fxLayoutAlign="start center" 
                         fxLayoutGap="16px" 
                         style="padding-top: 6px; padding-left: 20px; padding-bottom: 10px;">
                        <div>
                            <button matTooltip="Novo" mat-mini-fab color="primary" (click)="addTributo()">
                                <mat-icon>add</mat-icon>
                            </button>
                        </div>
                    </div>                
                </div>
            </div>
            -->
    
            
            <div dir="rtl" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px"
                style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px" fxFlexFill>

                <button mat-raised-button name="botaoLimpar" fxFlex="20%" color="primary" (click)="limpar()">
                    Limpar
                </button>

                <button *ngIf="!isAtualizar"  mat-raised-button name="botaoAdicionar" 
                        [disabled]="formulario.invalid"  
                        fxFlex="20%" color="primary" (click)="adicionar()">
                    Adicionar
                </button>

                <button *ngIf="isAtualizar" mat-raised-button name="botaoAdicionar" 
                        [disabled]="formulario.invalid || valorItensSuperiorValorMovimento"  
                        fxFlex="20%" color="primary" (click)="atualizar()">
                    Atualizar
                </button>

            </div>

        </mat-expansion-panel>
     

        <mat-expansion-panel [expanded]="!openFormCadastro" (opened)="carregarLista()"
            (closed)="openFormCadastro = true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <span>Lista de Itens ( {{movimentacoes.itensMovimentacoes?.length || 0}} ) -</span>
                    <span style="font-weight: 800; padding-left: 10px;" [style.color]="valorItensSuperiorValorMovimento ? 'red' : 'green'">Valor Total: {{getValorTotalItens() | currency: 'BRL'}}</span>      
                    <!--  
                        <span *ngIf="valorItensSuperiorValorMovimento" style="color: orangered; padding-left: 10px;">ATENÇÃO !!! A soma dos valores dos itens está diferente ao valor do movimento.</span>
                    -->
                </mat-panel-title>
            </mat-expansion-panel-header>


            <table *ngIf="mostrarTabela; else tabelaSemDados" mat-table [dataSource]="dataSource" style="margin-top: 20px">

                <ng-container matColumnDef="projetoContabil">
                    <th mat-header-cell *matHeaderCellDef> Projeto </th>
                    <td mat-cell *matCellDef="let element"> {{element.projeto?.nome}} </td>
                </ng-container>

                <ng-container matColumnDef="categoriaContabil">
                    <th mat-header-cell *matHeaderCellDef> Rubrica </th>
                    <td mat-cell *matCellDef="let element"> {{getRubricaPlanoConta(element.categoria?.id)}} </td>
                </ng-container>

                <ng-container matColumnDef="quantidadeMaterial">
                    <th mat-header-cell *matHeaderCellDef> Quantidade </th>
                    <td mat-cell *matCellDef="let element"> {{element.quantidadeMaterial}} </td>
                </ng-container>
               
                <ng-container matColumnDef="valorUnitarioItem">
                    <th mat-header-cell *matHeaderCellDef> Valor Unitário </th>
                    <td mat-cell *matCellDef="let element"> {{element.valorUnitarioItem | currency: 'BRL'}} </td>
                </ng-container>
               
                <ng-container matColumnDef="valorTotalItem">
                    <th mat-header-cell *matHeaderCellDef> Valor Total </th>
                    <td mat-cell *matCellDef="let element"> {{element.valorTotalItem | currency: 'BRL'}} </td>
                </ng-container>

                <ng-container matColumnDef="acoes">
                    <th mat-header-cell *matHeaderCellDef > Ações </th>
                    <td mat-cell *matCellDef="let element">
                        <button mat-button (click)="deletar(element)">
                            <mat-icon>delete</mat-icon>
                        </button>
                        <button  mat-button (click)="atualizarRegistro(element)">
                            <mat-icon>create</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

            <div [hidden]="!mostrarTabela">
                <mat-paginator [pageSizeOptions]="[5]" showFirstLastButtons></mat-paginator>
            </div>

            <ng-template #tabelaSemDados>
                <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 10px">
                    {{msg}}
                </div>
            </ng-template>

            <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="16px"
                style="padding-top: 30px">
                <div>
                    <button matTooltip="Adicionar novo item" mat-fab color="primary" (click)="novo()">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>


        </mat-expansion-panel>

    </mat-accordion>
</form>